var render = function render(){var _vm=this,_c=_vm._self._c;return _c('j-modal',{attrs:{"title":"答题记录","width":1000,"visible":_vm.visible,"maskClosable":false,"switchFullscreen":"","footer":null},on:{"cancel":function($event){_vm.visible = false}}},[_c('questionHistory',{ref:"questionHistory"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }